// extracted by mini-css-extract-plugin
module.exports = {"term":"term_term__2Q7g8","font":"term_font__1_AuW"};